module.exports = __webpack_public_path__ + "static/media/tutorial2.0bdcde86.jpg";